/**
* @params Nav
*/
export default function () {
    const winWidth=$(window).width();
    const winInnerHeight=$(window).innerHeight();
    const mobNavWrapper=$('.header__nav-wrapper').innerHeight();
    const subMenu=$('.header__main');
    const body=$('body');

    $('.hamburger--js').on('click', function (e) {
        e.preventDefault();
        if (winWidth<1024) {
            if (!subMenu.hasClass('open')) {
                $(this).addClass('active');
                subMenu.addClass('open');
                subMenu.slideDown();
            } else {
                $(this).removeClass('active');
                subMenu.removeClass('open');
                subMenu.slideUp();
            }
        } else {
            $(this).addClass('active');
            subMenu.addClass('open');
            subMenu.slideDown();
            body.addClass('body-hidden');
        }
    });

    $('.close-button--js').on('click', function (e) {
        e.preventDefault();

        subMenu.removeClass('active');
        subMenu.removeClass('open');
        body.removeClass('body-hidden');
        subMenu.slideUp();
    });

    $('.hamburger-mob--js').on('click', function (e) {
        if (winWidth<1024) {
            const heightDif=winInnerHeight-mobNavWrapper-100;

            $('.header__nav-wrapper').css("height", heightDif);
            $(this).toggleClass('open');
            body.toggleClass('body-hidden');
        }
    });

    $('.header__language, .search-button').hover(
        function () {
            $('.header__wrapper').addClass('no-hover');
        },
        function () {
            $('.header__wrapper').removeClass('no-hover');
        }
    );

    // Window Scroll
    const header=$('.header');
    let lastScrollTop=0;

    $(window).scroll(function (event) {
        const st=$(this).scrollTop();

        if (st>lastScrollTop) {
            // Scroll Down
            if (st>100) {
                header.addClass('js-snap-up');
            }
        } else {
            // Scroll Up
            header.removeClass('js-snap-up');
            header.addClass('js-shrink');
        }

        // Top most of the page
        if (st==0) {
            header.removeClass('js-snap-up, js-shrink');
        }

        lastScrollTop=st;
    });
}
